import { UseCase } from '@mdd/api';
import { User } from '../../models';

export class HasHilmarMemberCenterAccess implements UseCase<User | undefined, boolean> {
    execute(user: User | undefined): boolean {
        return (
            !!user &&
            (user.permissions.includes('HILMAR_MEMBER_CENTER_CA') ||
                user.permissions.includes('HILMAR_MEMBER_CENTER_TX') ||
                user.permissions.includes('HILMAR_MEMBER_CENTER_KS'))
        );
    }
}
